@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../../constants/spacing.module.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

.input-border-base-style() {
  border: 1px solid @product-page--input--border-color;
  &:focus-within {
    border-color: @product-page--input--focus--border-color;
  }
}

/* === Tab wrapper === */

.customs-tab {
  padding: @space-0 @space-16 @space-16;
}

/* === Main content card === */

.content-card {
  background-color: var(--white);
  border: 1px solid var(--default--border-color--10);
  border-radius: @space-4;
}

/* === Toggle section === */

.toggle-section {
  padding: @space-12 @space-16;
}

/* === Fields section === */

.section {
  padding: @space-16;
}

/* === Card subtitle === */

.subtitle {
  padding: @space-4 @space-0 @space-12;
}

/* === 2-column grid === */

.two-col-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: @space-16;
  padding: @space-8 @space-0;
}

.two-col-grid > * {
  min-width: 0;
}

/* === Labels === */

.label {
  padding: @space-4 @space-0;
  font-weight: 500;
}

/* === Description textarea === */

.description-textarea {
  width: 100%;
  height: 120px;
}

.description-textarea textarea {
  width: 100%;
  height: 100%;
  resize: vertical;
}

/* === Description block (relative container for textarea + suggest button) === */

.description-block {
  position: relative;
}

/* === Suggest row — top-anchored absolute so results grow downward (not upward).
     Button sits at bottom-right of textarea; results start just below it. === */

.suggest-row {
  position: absolute;
  /* textarea height(100%) minus bottom gap(8px) minus button height(~32px) */
  top: calc(100% - @space-8 - @space-32);
  left: 0;
  right: @space-8;
  z-index: 1;
}

/* Override shared component: right-align button within its container */
.suggest-row :global([class*='suggestionContainer']) {
  align-items: flex-end;
}

/* === Description footer helper text === */

.description-footer {
  padding: @space-4 @space-0 @space-8;
  color: var(--gray-637381);
}

/* === Field group (for full-width declared value) === */

.field-group {
  padding-top: @space-12;
}

/* === Declared value input (constrained width) === */

.declared-value-input {
  width: 280px;
}

/* === Currency input === */

.currency-input {
  height: 36px;
  .input-border-base-style();
}

/* === Text inputs === */

.input-wrapper Input {
  .input-border-base-style();
}

/* === No customs checkbox row === */

.no-customs-row {
  padding-top: @space-16;
}
